var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"general-wrapper"},[_c('Header',{attrs:{"parent":"corporate_users"},scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v("\n      "+_vm._s(_vm.$t("auditlog.title"))+"\n    ")]},proxy:true}])}),_c('IQOSTable',{attrs:{"cols":[
      {
        title: _vm.$t('auditlog.columns.user'),
        renderer: function (u) { return ((u.user_name) + " (" + (u.user_email) + ")"); }
      },
      {
        title: _vm.$t('auditlog.columns.date'),
        key: 'created_at',
        date: true,
        width: 160
      },
      {
        title: _vm.$t('auditlog.columns.time'),
        key: 'created_at',
        width: 80,
        time: true
      },
      {
        title: _vm.$t('auditlog.columns.action'),
        renderer: function (e) { return _vm.$t(("auditlog.types." + (e.type)), e.payload); } 
      } ],"rows":_vm.entries}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }